import React from 'react';
import StoryLayout from '../components/StoryLayout';
import storyData from '../story2.json';

const StorySecondYear = () => {
  return (
    <StoryLayout
      storyData={storyData}
      title="Kötéltánc"
      date="2026. május 9."
    />
  );
};

export default StorySecondYear;
